export const LOCAL_STORE = {
  MERCHANT_ID: "wallet_payment_request_merchantId",
  MERCHANT_TRANSACTION_ID: "wallet_payment_request_merchantTransactionId",
  CHECK_SUM: "wallet_payment_request_checksum",
  PAYMENT_MODULE: "payment_module",
  CHILD_KUNDALI_NAME: "child_kundali_name",
};
